// extracted by mini-css-extract-plugin
export var displayNone = "_o3-6";
export var imgContainer = "_o3-2";
export var overflowHidden = "_o3-3";
export var productInfoCardButtonContainer = "_o3-5";
export var productTitleText = "_o3-4";
export var rightArrow = "_o3-1";
export var rightArrowContainer = "_o3-0";